module.exports = __webpack_public_path__ + "img/icon-success.05bd9ef0.png";